import React from 'react';
import AnalizeClienti from './Analize';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';


export default class FisaClientului extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        listFise:null
}
    }

     componentDidMount(){
         this.getData()
    }

    getData = async() =>{
        let a = new AnalizeClienti()

        let data = await a.analizaSumeLunarePerClienti(24)

        this.setState({listFise:data})

        // console.log('data :', data);

    }
     render() { 
       return (
          <div>
                 {this.state.listFise && 
                    <div className='container'>
                    
                    <h1 className='pm-title'>{this.dictionary.financiarContabil.fisaClientului}</h1>

                        {this.state.listFise.map((f,idx)=>{
                            return(<div key={idx}> 
                                <h3 className='pm-title'>{f.client}</h3>

                                <Table style={{ width: '90%', margin: 'auto' }}>
                      <TableHead>
                          <TableRow style={{}}>

                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.anul}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.luna}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.nrFacturi}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.totalDeIncasat}
                              </TableCell>
                            


                          </TableRow>
                      </TableHead>

                      <TableBody>

                          {f.data.map((d,idx2)=>{
                                    return(
                    <TableRow  style={{ cursor: 'pointer' }} key={'row'+idx2}>
                                      <TableCell style={{ textAlign: 'center' }}>
                                          {d.an}
                                      </TableCell>

                                      <TableCell style={{ textAlign: 'center' }} >
                                          {d.luna}
                                      </TableCell>
                                      <TableCell style={{ textAlign: 'center' }} >
                                          {d.nrFacturi}
                                      </TableCell>
                                      <TableCell style={{ textAlign: 'center' }} >
                                          {d.totalDeIncasat}
                                      </TableCell>

                                  </TableRow>
                                    )
                                })}
                         
                      </TableBody>
                  </Table>   
                                
                            </div>)
                        })}
                    
                    </div>
                 }
         </div>
        );
       }
}